var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEloqua = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939BA0",
    d: "M12.931 6c4.863.006 8.814 3.903 8.904 8.74a5.245 5.245 0 0 0 5.247 5.075 5.247 5.247 0 0 0 5.25-5.075H36c-.085 4.838-4.05 8.738-8.918 8.738s-8.828-3.9-8.917-8.738a5.25 5.25 0 0 0-5.245-5.079 5.247 5.247 0 0 0-5.248 5.08H4C4.089 9.943 7.975 6.07 12.785 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E21836",
    d: "m32.333 34-.003-19.318a5.252 5.252 0 0 0-10.495.058c-.09 4.842-4.047 8.739-8.915 8.739-4.872 0-8.83-3.897-8.92-8.739h3.672a5.24 5.24 0 0 0 5.248 5.075c2.84 0 5.16-2.254 5.245-5.075C18.254 9.9 22.214 6 27.082 6c4.859 0 8.809 3.88 8.918 8.7V34z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEloqua);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eloqua.458acd27.svg";